import { FC } from "react";

import {
  FontIcon,
  FontSizes,
  mergeStyles,
  Stack,
  Text,
  TextBadge,
  TooltipHost
} from "@bps/fluent-ui";
import { routes } from "@libs/routing/routes.ts";
import { Navigate } from "@ui-components/navigation/Navigate.tsx";

import { ClaimStatusBadgeProps } from "./ClaimStatusBadge.types.ts";
import { wrapBadge } from "./utils.tsx";

export const ClaimStatusCompactBadge: FC<ClaimStatusBadgeProps> = props => {
  return wrapBadge(
    <TooltipHost
      content={
        <Stack horizontal tokens={{ childrenGap: 16 }}>
          <Text styles={{ root: { fontSize: "inherit" } }}>{props.text}</Text>
          {props.claimId ? (
            <Navigate
              to={routes.claims.management.edit.path({ id: props.claimId })}
            >
              Go to claim
            </Navigate>
          ) : null}
        </Stack>
      }
    >
      {props.displayIcon ? (
        <FontIcon
          iconName={props.icon}
          styles={{
            root: {
              color: props.textColor,
              marginRight: 4,
              fontSize: FontSizes.size14,
              ...props.styles?.icon
            }
          }}
        />
      ) : (
        <TextBadge
          badgeColor={props.badgeColor}
          hasBorder={props.hasBorder}
          styles={{
            root: mergeStyles(
              {
                width: 18,
                height: 18,
                padding: 2,
                borderRadius: 5,
                lineHeight: 10,
                fontSize: 10
              },
              props.styles?.badge
            )
          }}
        >
          {props.text?.charAt(0).toUpperCase()}
        </TextBadge>
      )}
    </TooltipHost>,
    props.styles?.root
  );
};
